import React, {Component} from 'react';
import util from 'Utils/commonUtil';
// Components
import {Card, Grid, Checkbox} from '@material-ui/core';
import Counter from 'Components/counter/Counter';
import Dialog from 'Components/common/Dialog';
import BasicButton from 'Components/common/BasicButton';
import ProductImage from 'Components/commonOrder/ProductImage';

// Actions
import {T} from 'Actions/translate';
import {loadLanguage} from 'Utils/jwtUtil';
import {PRODUCT_SOURCE, PURCHASE_ORDER_MODE} from 'Utils/constant';
import Promotions from '../common/Promotions';
import {operationLog} from 'Actions/order';

class ProductCard extends Component {
    state = {
        dialogOpened: false,
        customerInfoOpened: false,
        isQuoteInfor: false,
        quoteDetailsOpened: false,
        num: 0,
        checked: true,
        isAddReduceStatus: null,
        assayIdValue: '',
    };

    constructor() {
        super();
        this.counterComponent = React.createRef();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.defaultCheck !== this.props.defaultCheck) {
            this.setState({
                checked: nextProps.defaultCheck,
            });
        }
        if (nextProps.isQuoteInfor !== this.props.isQuoteInfor) {
            this.setState({
                isQuoteInfor: nextProps.isQuoteInfor,
            });
        }
        if (nextProps.reselectAllProductCheck) {
            this.setState({
                checked: nextProps.reselectAllProductCheck,
            });
        }
    }

    openDetails = (sku, productInfo) => {
        let pageType = this.props.currentProductType;
        if (this.props.isProxyProcessType && !this.props.addPageType) {
            pageType = this.props.isProxyProcessType;
        }

        this.setState({
            dialogOpened: true,
        });

        this.props.operation(sku);
    };

    closeDetails = () => {
        if (this.state.dialogOpened) {
            this.setState({
                dialogOpened: false,
            });
        }
    };

    openCustomerInfo = () => {
        this.setState({
            customerInfoOpened: true,
        });
    };

    closeCustomerInfo = () => {
        if (this.state.customerInfoOpened) {
            this.setState({
                customerInfoOpened: false,
            });
        }
    };

    isOfflineOemProduct = (productInfo) => {
        return (
            productInfo.type !== 2 &&
            productInfo.productSource === PRODUCT_SOURCE.OEM &&
            util.getPurchaseOrderMode() === PURCHASE_ORDER_MODE.OFFLINE
        );
    };

    openQuoteDetails = (param) => {
        this.setState({
            quoteDetailsOpened: true,
        });
        operationLog({
            opTarget: 'view_promo_detail',
            opContent: param,
            opReqUrl: 'api/quote/sku',
        });
    };

    closeQuoteDetails = () => {
        if (this.props.closeQuoteDetails) {
            this.props.closeQuoteDetails();
        }
        if (this.state.quoteDetailsOpened) {
            this.setState({
                quoteDetailsOpened: false,
            });
        }
    };

    copyContent = (text) => {
        this.closeQuoteDetails();

        if (this.props.copyContent) {
            this.props.copyContent(text);
        }
    };

    changeNum = (value, operationFlag) => {
        const {productInfo} = this.props;
        //判断是加还是减
        this.setState(
            {
                num: value,
                isAddReduceStatus: operationFlag,
            },
            () => {
                if (this.props.changeNum) {
                    this.props.changeNum(
                        this.props.cartInfo,
                        value,
                        this.state.isAddReduceStatus,
                    );
                }
            },
        );
        // if (productInfo.freeGoodItem !== 'undefined' && productInfo.freeGoodItem) {
        //     this.props.openNotification(T(''));
        // } else {
        //     //判断是加还是减
        //     this.setState(
        //         {
        //             num: value,
        //             isAddReduceStatus: operationFlag,
        //         },
        //         () => {
        //             if (this.props.changeNum) {
        //                 this.props.changeNum(
        //                     this.props.cartInfo,
        //                     value,
        //                     this.state.isAddReduceStatus,
        //                 );
        //             }
        //         },
        //     );
        // }
    };

    handleCheck = (name) => (event) => {
        this.setState({[name]: event.target.checked});
        if (this.props.handleCheck) {
            this.props.handleCheck(
                event.target.checked,
                this.state.num || this.props.cartInfo.quantity,
                this.props.cartInfo,
            );
        }
    };

    // savingPrice = (productInfo) => {
    // 	const { codeList } = this.props;

    // 	let savingPrice = parseFloat(productInfo.listPrice || 0.00) - parseFloat(codeList.length < 1 ? productInfo.onlinePrice || productInfo.finalPrice || 0.00 : productInfo.finalPrice || 0.00);
    // 	return util.toMoney(savingPrice);
    // }

    comparePrice = (listPrice, efPrice) => {
        let flg = true;

        if (
            (efPrice &&
                listPrice &&
                parseFloat(efPrice) > parseFloat(listPrice)) ||
            !efPrice
        ) {
            flg = false;
        }

        return flg;
    };

    addShoppingCart = (productInfo, num) => (event) => {
        if (this.props.addShoppingCart) {
            this.props.addShoppingCart(productInfo, num, event);
        }
    };

    showDiscountPriceFun = () => {
        let {codeList} = this.props;
        let isDiscountPrice = false;
        codeList &&
            codeList.length > 0 &&
            codeList.forEach((codeItem) => {
                if (codeItem.trim().substring(0, 1).toUpperCase() === 'S') {
                    isDiscountPrice = true;
                }
            });
        return isDiscountPrice;
    };

    showApplyQuotePreferentialPrice = (
        onlinePrice,
        displayOnlinePrice,
        skuPricesObj,
    ) => {
        let priceLabelFlag = '';
        const {cartPrice, discountCode} = this.props;
        if (cartPrice.data && cartPrice.data.promoCodes.length > 0) {
            if (
                cartPrice.data.promoCodes.length <= 1 &&
                !(discountCode && discountCode.trim()) &&
                cartPrice.data.promoCodes[0].substring(0, 1).toUpperCase() ===
                    'S'
            ) {
                priceLabelFlag = false;
            } else {
                if (typeof skuPricesObj !== 'undefined' && skuPricesObj) {
                    if (skuPricesObj.priceType === 'discount') {
                        priceLabelFlag = true;
                    } else if (skuPricesObj.priceType === 'wop') {
                        priceLabelFlag = true;
                    } else if (skuPricesObj.priceType === 'yourPrice') {
                        priceLabelFlag = false;
                    }
                }
            }
        } else {
            priceLabelFlag = false;
        }

        return priceLabelFlag;
    };

    showPriceTypeLabel = (onlinePrice, displayOnlinePrice, skuPricesObj) => {
        let priceLabel = '';
        const {cartPrice} = this.props;
        if (cartPrice.data && cartPrice.data.promoCodes.length > 0) {
            // console.log(
            //     'showPriceTypeLabel==================================cartPrice.data.promoCodes',
            //     cartPrice,
            // );
            // console.log(
            //     'showPriceTypeLabel==================================skuPricesObj',
            //     skuPricesObj,
            // );
            if (cartPrice.status === 'success') {
                if (typeof skuPricesObj !== 'undefined' && skuPricesObj) {
                    if (
                        cartPrice.data.promoCodes.length === 1 &&
                        cartPrice.data.promoCodes[0]
                            .substring(0, 1)
                            .toUpperCase() === 'S'
                    ) {
                        if (onlinePrice && displayOnlinePrice) {
                            priceLabel = 'order_global_price';
                        } else {
                            priceLabel = 'order_preferential_price';
                        }
                    } else {
                        if (skuPricesObj.priceType === 'discount') {
                            priceLabel = 'order_discount_price';
                        } else if (skuPricesObj.priceType === 'wop') {
                            priceLabel = 'order_global_price';
                        } else if (skuPricesObj.priceType === 'yourPrice') {
                            priceLabel = 'order_preferential_price';
                        }
                    }
                } else {
                    if (onlinePrice && displayOnlinePrice) {
                        priceLabel = 'order_global_price';
                    } else {
                        priceLabel = 'order_preferential_price';
                    }
                }
            } else if (
                cartPrice.status !== 'success' &&
                cartPrice.status !== 'cmgt_error'
            ) {
                if (typeof skuPricesObj !== 'undefined' && skuPricesObj) {
                    if (
                        cartPrice.data.promoCodes.length === 1 &&
                        cartPrice.data.promoCodes[0]
                            .substring(0, 1)
                            .toUpperCase() === 'S'
                    ) {
                        if (onlinePrice && displayOnlinePrice) {
                            priceLabel = 'order_global_price';
                        } else {
                            priceLabel = 'order_preferential_price';
                        }
                    } else {
                        if (skuPricesObj.priceType === 'discount') {
                            priceLabel = 'order_discount_price';
                        } else if (skuPricesObj.priceType === 'wop') {
                            priceLabel = 'order_global_price';
                        } else if (skuPricesObj.priceType === 'yourPrice') {
                            priceLabel = 'order_preferential_price';
                        }
                    }
                } else {
                    if (onlinePrice && displayOnlinePrice) {
                        priceLabel = 'order_global_price';
                    } else {
                        priceLabel = 'order_preferential_price';
                    }
                }
            }
        } else {
            if (onlinePrice && displayOnlinePrice) {
                priceLabel = 'order_global_price';
            } else {
                priceLabel = 'order_preferential_price';
            }
        }

        return priceLabel;
    };

    showLastPrice = (
        displayOnlinePrice,
        skuPricesObj,
        updatedInfo,
        productInfo,
    ) => {
        let lastPrice = 0;
        const latestProductPrice = displayOnlinePrice
            ? productInfo.onlinePrice ||
              productInfo.finalPrice ||
              productInfo.efPrice
            : productInfo.efPrice ||
              productInfo.finalPrice ||
              productInfo.onlinePrice;
        // console.log(
        //     'showLastPrice==========================skuPricesObj',
        //     skuPricesObj,
        // );
        // console.log(
        //     'showLastPrice==========================productInfo',
        //     productInfo,
        // );
        const {cartPrice, updateChoosePrice} = this.props;

        if (
            productInfo.type === 2 &&
            latestProductPrice !== undefined &&
            latestProductPrice !== null &&
            latestProductPrice !== '' &&
            (!cartPrice.data ||
                !cartPrice.data.promoCodes ||
                cartPrice.data.promoCodes.length === 0)
        ) {
            return latestProductPrice;
        }
        if (cartPrice.data && cartPrice.data.promoCodes.length > 0) {
            if (typeof skuPricesObj !== 'undefined' && skuPricesObj) {
                if (
                    cartPrice.data.promoCodes.length === 1 &&
                    cartPrice.data.promoCodes[0]
                        .substring(0, 1)
                        .toUpperCase() === 'S'
                ) {
                    if (displayOnlinePrice) {
                        lastPrice =
                            skuPricesObj.onlinePrice || skuPricesObj.finalPrice;
                    } else {
                        lastPrice =
                            skuPricesObj.efPrice || skuPricesObj.finalPrice;
                    }
                } else {
                    lastPrice = skuPricesObj.finalPrice;
                }
                // console.log("1111111111111111111111111111111111111111");
            } else {
                // console.log("22222222222222222222222222222222222222");
                if (!displayOnlinePrice) {
                    lastPrice = productInfo.efPrice || productInfo.finalPrice;
                } else {
                    lastPrice =
                        productInfo.onlinePrice || productInfo.finalPrice;
                }
            }
        } else {
            // console.log("33333333333333333333333333333333333333333333");
            if (
                cartPrice.status !== 'success' &&
                cartPrice.status !== 'cmgt_error'
            ) {
                if (
                    typeof updateChoosePrice !== 'undefined' &&
                    updateChoosePrice &&
                    updateChoosePrice === 'switchPrice'
                ) {
                    if (!displayOnlinePrice) {
                        if (
                            typeof skuPricesObj !== 'undefined' &&
                            skuPricesObj
                        ) {
                            lastPrice = skuPricesObj.finalPrice;
                        } else {
                            lastPrice =
                                productInfo.efPrice || productInfo.finalPrice;
                        }
                    } else {
                        if (
                            typeof skuPricesObj !== 'undefined' &&
                            skuPricesObj
                        ) {
                            lastPrice =
                                skuPricesObj.onlinePrice ||
                                skuPricesObj.finalPrice;
                        } else {
                            lastPrice =
                                productInfo.onlinePrice ||
                                productInfo.finalPrice;
                        }
                    }
                } else {
                    lastPrice =
                        typeof skuPricesObj !== 'undefined' &&
                        skuPricesObj &&
                        typeof skuPricesObj.finalPrice !== 'undefined' &&
                        skuPricesObj.finalPrice;
                }
            } else {
                if (
                    cartPrice.status === 'success' &&
                    typeof skuPricesObj !== 'undefined' &&
                    skuPricesObj
                ) {
                    if (!displayOnlinePrice) {
                        lastPrice =
                            skuPricesObj.efPrice || skuPricesObj.finalPrice;
                    } else {
                        lastPrice =
                            skuPricesObj.onlinePrice || skuPricesObj.finalPrice;
                    }
                } else {
                    if (!displayOnlinePrice) {
                        lastPrice =
                            productInfo.efPrice || productInfo.finalPrice;
                    } else {
                        lastPrice =
                            productInfo.onlinePrice || productInfo.finalPrice;
                    }
                }
            }
        }

        return lastPrice || latestProductPrice;
    };

    formatLastPrice = (price) => {
        return price === undefined ||
            price === null ||
            price === '' ||
            Number.isNaN(Number(price))
            ? '--'
            : util.toMoney(price);
    };

    showApplyQuoteListPrice = (
        onlinePrice,
        displayOnlinePrice,
        skuPricesObj,
        productInfo,
    ) => {
        const {cartPrice, updateChoosePrice} = this.props;
        let listPrice = 0;
        if (
            this.isUpdateChoosePrice() ||
            (cartPrice.status === 'success' &&
                cartPrice.data &&
                cartPrice.data.length > 0)
        ) {
            if (typeof skuPricesObj !== 'undefined' && skuPricesObj) {
                listPrice = skuPricesObj.listPrice;
            }
        } else {
            listPrice = productInfo.listPrice;
        }
        return listPrice;
    };

    isUpdateChoosePrice = () => {
        const {updateChoosePrice} = this.props;
        let isChange = false;
        if (
            typeof updateChoosePrice !== 'undefined' &&
            updateChoosePrice &&
            updateChoosePrice === 'switchPrice'
        ) {
            isChange = true;
        }
        return isChange;
    };

    showAssayIdInputArea = () => {
        const {item} = this.props;
        let isShowAssayIdInputAreaFlag = false;
        if (util.getPropertyExistsAndIsTrue(item)) {
            if (
                item.assayIdRequired &&
                !util.getPropertyExistsAndIsTrue(item.displayAttributeList)
            ) {
                isShowAssayIdInputAreaFlag = true;
            }
        }

        return isShowAssayIdInputAreaFlag;
    };

    showAssayIdContent = () => {
        const {item} = this.props;
        let isShowAssayIdContent = false;
        if (util.getPropertyExistsAndIsTrue(item)) {
            if (
                item.assayIdRequired &&
                util.getPropertyExistsAndIsTrue(item.displayAttributeList) &&
                item.displayAttributeList.length > 0
            ) {
                isShowAssayIdContent = true;
            }
        }

        return isShowAssayIdContent;
    };

    changeAssayidValue = (assayIdValue) => (event) => {
        this.setState({
            assayIdValue: event.target.value,
        });
    };

    checkedAssayId = (item, assayIdValue) => {
        this.props.checkedAssayIdHandle(item, assayIdValue);
    };

    showOtherDivision = (productInfo, otherDivision) => {
        if (
            otherDivision &&
            !productInfo.skuPermission &&
            productInfo.skuDivisions &&
            productInfo.skuDivisions.length > 0
        ) {
            return (
                <div class="text-overlay">
                    {productInfo.skuDivisions.map(
                        (skuDivision, skuDivisionIndex) => (
                            <div
                                class="text-overlay-content"
                                testid="product-division-permission"
                                key={skuDivisionIndex}>
                                {skuDivision}
                            </div>
                        ),
                    )}
                </div>
            );
        }
    };

    render() {
        const {
            productInfo,
            item,
            isProduct,
            isShoppingCart,
            cartInfo,
            updatedInfo,
            displayOnlinePrice,
            isDemoSite,
            codeList,
            skuPricesObj,
            sPrice,
            quoteInfor,
            cartPrice,
            discountCode,
            otherDivision,
        } = this.props;
        const {
            dialogOpened,
            num,
            checked,
            customerInfoOpened,
            quoteDetailsOpened,
            assayIdValue,
        } = this.state;
        const target =
            quoteInfor &&
            quoteInfor.find((item) => item.sku === productInfo.sku);
        const hasQuote =
            target && target.promotions && target.promotions.length > 0;
        const createMarkup = (text) => ({__html: text});
        let lang = loadLanguage();
        // console.log('skuPricesObj=================', skuPricesObj);
        // console.log(
        //     'ProductCard======================================cartPrice=================',
        //     cartPrice,
        // );

        return (
            <Card
                testid="product-card"
                data-sku={productInfo.sku}
                className={
                    !productInfo.available && isShoppingCart
                        ? 'product-card disabled'
                        : 'product-card'
                }>
                {productInfo.type === 2 ? (
                    <div className="tf-warning-message">
                        <span
                            testid={
                                isShoppingCart
                                    ? 'shopping-cart-item-website-delivery-indicator'
                                    : 'tm-website-delivery-indicator'
                            }>
                            {T('order_global_delivery')}
                        </span>
                    </div>
                ) : null}

                {isShoppingCart && !productInfo.freeGoodItem ? (
                    <div
                        className={
                            !productInfo.available
                                ? 'checkbox'
                                : 'checkbox adjust-checkbox'
                        }>
                        <Checkbox
                            checked={checked}
                            inputProps={{
                                'data-testid': 'shopping-cart-item-checkbox',
                            }}
                            onChange={this.handleCheck('checked')}
                        />
                    </div>
                ) : null}

                <div
                    testid="cart-item"
                    data-sku={productInfo.sku}
                    className={
                        isShoppingCart
                            ? 'card-content adjust-width'
                            : 'card-content'
                    }>
                    <Grid className="top-content" container spacing={0}>
                        <Grid className="left-content-grid" item xs={3}>
                            {hasQuote ? (
                                <div
                                    className={
                                        otherDivision
                                            ? 'image-box image-border other-division'
                                            : 'image-box image-border'
                                    }
                                    onClick={() =>
                                        this.openQuoteDetails(productInfo.sku)
                                    }>
                                    <ProductImage
                                        src={productInfo.productPic}
                                        alt={productInfo.productName}
                                        key={productInfo.productPic}
                                    />
                                    {this.showOtherDivision(
                                        productInfo,
                                        otherDivision,
                                    )}
                                    <div className="quote-box">
                                        <span className="quote-icon">
                                            {T('quote_icon')}
                                        </span>
                                    </div>
                                </div>
                            ) : (
                                <div
                                    className={
                                        otherDivision
                                            ? 'image-box other-division'
                                            : 'image-box'
                                    }>
                                    <ProductImage
                                        src={productInfo.productPic}
                                        alt={productInfo.productName}
                                        key={productInfo.productPic}
                                    />
                                    {this.showOtherDivision(
                                        productInfo,
                                        otherDivision,
                                    )}
                                </div>
                            )}
                        </Grid>

                        <Grid className="right-content-grid" item xs={9}>
                            <Grid
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid className="product-title" item xs={12}>
                                    <div
                                        className="checkbox-text"
                                        dangerouslySetInnerHTML={createMarkup(
                                            productInfo.productName,
                                        )}
                                    />
                                    {isProduct ? (
                                        <span
                                            className="product-title-btn"
                                            onClick={() =>
                                                this.openDetails(
                                                    productInfo.sku,
                                                    productInfo,
                                                )
                                            }>
                                            {T('moreDetails')}
                                        </span>
                                    ) : null}
                                </Grid>
                            </Grid>

                            {lang !== 'EN' ? (
                                <Grid
                                    className="product-details"
                                    container
                                    spacing={0}>
                                    <Grid item xs={7}>
                                        <span>{T('sku')}:</span>
                                        <span testid="product-sku">
                                            {productInfo.sku}
                                        </span>
                                    </Grid>
                                    {productInfo.type !== 2 ? (
                                        <Grid item xs={5}>
                                            <span>{T('inventory')}:</span>
                                            <span>
                                                {productInfo.inventory > 0
                                                    ? productInfo.inventory
                                                    : 0}
                                            </span>
                                        </Grid>
                                    ) : (
                                        <Grid item xs={5}>
                                            {(typeof productInfo.availableInventory !==
                                                'undefined' &&
                                                productInfo.availableInventory) ||
                                            productInfo.availableInventory ===
                                                0 ? (
                                                <span>{T('inventory')}:</span>
                                            ) : null}

                                            <span testid="tm-website-inventory-status">
                                                {productInfo.availableInventory ===
                                                0
                                                    ? T('stockout')
                                                    : productInfo.availableInventory >
                                                          0 &&
                                                      productInfo.availableInventory <=
                                                          10
                                                    ? T('short_of_stock')
                                                    : productInfo.availableInventory >
                                                      10
                                                    ? T('in_stock')
                                                    : null}
                                            </span>
                                        </Grid>
                                    )}
                                </Grid>
                            ) : (
                                <Grid
                                    className="product-details"
                                    container
                                    spacing={0}>
                                    <Grid item xs={12}>
                                        <span>{T('sku')}:</span>
                                        <span testid="product-sku">
                                            {productInfo.sku}
                                        </span>
                                    </Grid>
                                    {productInfo.type !== 2 ? (
                                        <Grid item xs={12}>
                                            <span>{T('inventory')}:</span>
                                            <span>
                                                {productInfo.inventory > 0
                                                    ? productInfo.inventory
                                                    : 0}
                                            </span>
                                        </Grid>
                                    ) : (typeof productInfo.availableInventory !==
                                          'undefined' &&
                                          productInfo.availableInventory) ||
                                      productInfo.availableInventory === 0 ? (
                                        <Grid item xs={12}>
                                            <span>{T('inventory')}:</span>

                                            <span testid="tm-website-inventory-status">
                                                {productInfo.availableInventory ===
                                                0
                                                    ? T('stockout')
                                                    : productInfo.availableInventory >
                                                          0 &&
                                                      productInfo.availableInventory <=
                                                          10
                                                    ? T('short_of_stock')
                                                    : productInfo.availableInventory >
                                                      10
                                                    ? T('in_stock')
                                                    : null}
                                            </span>
                                        </Grid>
                                    ) : null}
                                </Grid>
                            )}

                            {hasQuote ? (
                                <Grid
                                    className="product-details"
                                    container
                                    spacing={0}>
                                    <Grid item xs={7}>
                                        <span>{T('specifications')}:</span>
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: productInfo.specifications,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={5}>
                                        <span
                                            className="product-quote-btn"
                                            onClick={() =>
                                                this.openQuoteDetails(
                                                    productInfo.sku,
                                                )
                                            }>
                                            {T('quote_details')}
                                        </span>
                                    </Grid>
                                </Grid>
                            ) : (
                                <Grid
                                    className="product-details"
                                    container
                                    spacing={0}>
                                    <Grid item xs={12}>
                                        <span>{T('specifications')}:</span>
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: productInfo.specifications,
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            )}

                            {productInfo.type === 1 && productInfo.eta && (
                                <Grid
                                    className="product-details"
                                    container
                                    spacing={0}>
                                    <Grid item xs={12}>
                                        <span>{T('product_eta')}:</span>
                                        <span>{productInfo.eta}</span>
                                    </Grid>
                                </Grid>
                            )}

                            {isShoppingCart && this.showAssayIdInputArea() && (
                                <div className="assayid-wrapper">
                                    <input
                                        className="assayid-input"
                                        value={assayIdValue}
                                        type="text"
                                        placeholder={T(
                                            'shopping_cart_assayid_placeholder',
                                        )}
                                        onChange={this.changeAssayidValue()}
                                    />
                                    <BasicButton
                                        type="primary"
                                        className="checked-assayid-btn"
                                        onClickOfSingleTap={() =>
                                            this.checkedAssayId(
                                                item,
                                                assayIdValue,
                                            )
                                        }>
                                        {T('shopping_cart_assayid_checked')}
                                    </BasicButton>
                                </div>
                            )}

                            {isShoppingCart && this.showAssayIdContent() && (
                                <div className="assayid-content-wrapper">
                                    {item.displayAttributeList.map(
                                        (assayIdItem, assayIdIndex) => (
                                            <div
                                                className="assayIdArea"
                                                key={assayIdIndex}>
                                                <label
                                                    style={{
                                                        marginRight: '5px',
                                                    }}>
                                                    {assayIdItem.displayName}:
                                                </label>
                                                <span className="assayIdLabel">
                                                    {assayIdItem.displayValue}
                                                </span>
                                            </div>
                                        ),
                                    )}
                                </div>
                            )}
                        </Grid>
                    </Grid>

                    {isProduct ? (
                        <div>
                            {/* TODO */}
                            {productInfo.skuPermission &&
                            productInfo.available ? (
                                <Grid
                                    className="bottom-content"
                                    container
                                    spacing={0}>
                                    {this.isOfflineOemProduct(productInfo) ? (
                                        <Grid
                                            className="list-price-grid"
                                            item
                                            xs={5}>
                                            <Grid
                                                className="list-price"
                                                container
                                                spacing={0}>
                                                <span
                                                    className="price-font"
                                                    testid="oem_product_price">
                                                    {T(
                                                        'oem_custom_order_product',
                                                    )}
                                                </span>
                                            </Grid>
                                        </Grid>
                                    ) : (
                                        <React.Fragment>
                                            <Grid
                                                className="list-price-grid"
                                                item
                                                xs={12}>
                                                {productInfo.onlinePrice ? (
                                                    <Grid
                                                        className="list-price"
                                                        container
                                                        spacing={0}>
                                                        <span
                                                            className={
                                                                'discount-price-display price-font'
                                                            }>
                                                            {util.toMoney(
                                                                productInfo.efPrice ||
                                                                    0,
                                                            )}
                                                        </span>
                                                        <span className="discount-price-label">
                                                            {T(
                                                                'order_your_preferential_price',
                                                            )}
                                                        </span>
                                                        <span className="list-price-display line-through price-font">
                                                            {util.toMoney(
                                                                productInfo.listPrice ||
                                                                    0,
                                                            )}
                                                        </span>
                                                        <span className="list-price-label">
                                                            {T(
                                                                'order_list_price',
                                                            )}
                                                        </span>
                                                    </Grid>
                                                ) : (
                                                    <Grid
                                                        className="list-price"
                                                        container
                                                        spacing={0}>
                                                        {this.comparePrice(
                                                            productInfo.listPrice,
                                                            productInfo.efPrice,
                                                        ) ? (
                                                            <React.Fragment>
                                                                <span className="list-price-display line-through price-font">
                                                                    {util.toMoney(
                                                                        productInfo.listPrice ||
                                                                            0,
                                                                    )}
                                                                </span>
                                                                <span className="list-price-label">
                                                                    {T(
                                                                        'order_list_price',
                                                                    )}
                                                                </span>
                                                            </React.Fragment>
                                                        ) : null}
                                                    </Grid>
                                                )}
                                            </Grid>
                                            <Grid
                                                className="list-price-grid"
                                                item
                                                xs={5}>
                                                <Grid
                                                    className="list-price"
                                                    container
                                                    spacing={0}>
                                                    <span className="price-label">
                                                        <i className="rmb"></i>{' '}
                                                    </span>
                                                    <span className="price-font">
                                                        {util.toMoney(
                                                            !isDemoSite
                                                                ? productInfo.onlinePrice ||
                                                                      productInfo.finalPrice
                                                                : productInfo.listPrice,
                                                        )}
                                                    </span>
                                                    <span className="online-price-display">
                                                        {!isDemoSite
                                                            ? productInfo.onlinePrice
                                                                ? T(
                                                                      'order_global_price',
                                                                  )
                                                                : T(
                                                                      'order_your_preferential_price',
                                                                  )
                                                            : T(
                                                                  'order_list_price',
                                                              )}
                                                    </span>
                                                </Grid>
                                            </Grid>
                                        </React.Fragment>
                                    )}
                                    <Grid className="counter" item xs={4}>
                                        <Counter
                                            inputValid={this.changeNum}
                                            defalutValue={1}
                                            testid="product-quantity"
                                            options={{min: 1}}></Counter>
                                    </Grid>
                                    <Grid
                                        className="add-to-shopping-cart"
                                        item
                                        xs={3}>
                                        <BasicButton
                                            type="primary"
                                            testid="add-to-shopping-cart-btn"
                                            disabled={
                                                productInfo.available
                                                    ? false
                                                    : true
                                            }
                                            onClickOfSingleTap={this.addShoppingCart(
                                                productInfo,
                                                num || 1,
                                            )}>
                                            {T('addToShoppingCart')}
                                        </BasicButton>
                                    </Grid>
                                </Grid>
                            ) : !productInfo.skuPermission ? null : (
                                <Grid
                                    className="bottom-content"
                                    container
                                    spacing={0}>
                                    <Grid
                                        className="list-price-grid"
                                        item
                                        xs={5}>
                                        <Grid
                                            className="list-price"
                                            container
                                            spacing={0}>
                                            <span
                                                testid="product_contact_us"
                                                onClick={this.openCustomerInfo}>
                                                {T('order_contact_us')}
                                            </span>
                                        </Grid>
                                    </Grid>
                                    <Grid className="counter" item xs={4}>
                                        <Counter
                                            inputValid={this.changeNum}
                                            defalutValue={1}
                                            testid="product-quantity"
                                            options={{min: 1}}></Counter>
                                    </Grid>
                                    <Grid
                                        className="add-to-shopping-cart"
                                        item
                                        xs={3}>
                                        <div className="product-image">
                                            <ProductImage
                                                src={productInfo.productPic}
                                                alt={productInfo.productName}
                                                key={productInfo.productPic}
                                            />
                                        </div>
                                        <BasicButton
                                            type="primary"
                                            testid="add-to-shopping-cart-btn"
                                            disabled={
                                                productInfo.available
                                                    ? false
                                                    : true
                                            }
                                            onClickOfSingleTap={this.addShoppingCart(
                                                productInfo,
                                                num || 1,
                                            )}>
                                            {T('addToShoppingCart')}
                                        </BasicButton>
                                    </Grid>
                                </Grid>
                            )}
                        </div>
                    ) : null}

                    {isShoppingCart && productInfo.available ? (
                        <Grid className="bottom-content" container spacing={0}>
                            {this.isOfflineOemProduct(productInfo) ? (
                                <Grid className="list-price-grid" item xs={8}>
                                    <Grid className="list-price" item xs={12}>
                                        <span
                                            className="price-font"
                                            testid="shopping_cart_oem_product_price">
                                            {T('oem_custom_order_product')}
                                        </span>
                                    </Grid>
                                </Grid>
                            ) : (
                                <React.Fragment>
                                    {this.comparePrice(
                                        productInfo.listPrice,
                                        productInfo.efPrice,
                                    ) ? (
                                        <Grid
                                            className="list-price-grid"
                                            item
                                            xs={12}>
                                            <div className="list-price apply-code-list-price">
                                                {this.showApplyQuotePreferentialPrice(
                                                    productInfo.onlinePrice,
                                                    displayOnlinePrice,
                                                    skuPricesObj,
                                                ) > 0 ? (
                                                    <div className="apply-code-preferential-price">
                                                        <span
                                                            className="list-price-display line-through price-font"
                                                            testid="shopping_cart_ef_price">
                                                            {util.toMoney(
                                                                productInfo.efPrice ||
                                                                    0,
                                                            )}
                                                        </span>
                                                        <span className="list-price-label">
                                                            {T(
                                                                'order_preferential_price',
                                                            )}
                                                        </span>
                                                    </div>
                                                ) : null}
                                                <div>
                                                    <span
                                                        className="list-price-display line-through price-font"
                                                        testid="shopping_cart_list_price">
                                                        {util.toMoney(
                                                            productInfo.listPrice ||
                                                                0,
                                                        )}

                                                        {/* {util.toMoney(this.showApplyQuoteListPrice(
                                                    displayOnlinePrice,
                                                    skuPricesObj,
                                                    updatedInfo,
                                                    productInfo))} */}
                                                    </span>
                                                    <span className="list-price-label">
                                                        {T('order_list_price')}
                                                    </span>
                                                </div>
                                            </div>
                                        </Grid>
                                    ) : null}

                                    <Grid
                                        className="list-price-grid"
                                        item
                                        xs={8}>
                                        <Grid container spacing={0}>
                                            <Grid
                                                className="list-price"
                                                item
                                                xs={12}>
                                                <i className="rmb"></i>{' '}
                                                <span
                                                    className="price-font"
                                                    testid="shopping_cart_last_price">
                                                    {this.formatLastPrice(
                                                        this.showLastPrice(
                                                            displayOnlinePrice,
                                                            skuPricesObj,
                                                            updatedInfo,
                                                            productInfo,
                                                        ),
                                                    )}
                                                </span>
                                                <span
                                                    className="price-label"
                                                    testid="shopping_cart_last_price_value">
                                                    {T(
                                                        this.showPriceTypeLabel(
                                                            productInfo.onlinePrice,
                                                            displayOnlinePrice,
                                                            skuPricesObj,
                                                        ),
                                                    )}
                                                </span>
                                            </Grid>

                                            {/*					      		<Grid className='saving-details' item xs={12}>
									{this.savingPrice(productInfo) !== '0.00' ? <span>节省：¥ {this.savingPrice(productInfo)}</span> : null}
					      		</Grid>*/}

                                            {/*					      		{updatedInfo && updatedInfo.activeCode ? <Grid className='discount-details' item xs={12}>
									<span>促销代码：{updatedInfo.activeCode}</span>
					      		</Grid> : null }*/}
                                        </Grid>
                                    </Grid>
                                </React.Fragment>
                            )}
                            <Grid className="counter-shopping-cart" item xs={4}>
                                {productInfo.freeGoodItem !== 'undefined' &&
                                productInfo.freeGoodItem ? (
                                    <span>x{cartInfo.quantity}</span>
                                ) : (
                                    <Counter
                                        inputValid={this.changeNum}
                                        defalutValue={cartInfo.quantity}
                                        cartFlag={true}
                                        testid="shopping-cart-counter"
                                        options={{min: 1}}></Counter>
                                )}
                            </Grid>
                        </Grid>
                    ) : null}

                    {this.props.children}
                </div>

                <Dialog
                    contentStyle={{width: '100%'}}
                    dialogDidClose={this.closeDetails}
                    opened={dialogOpened}
                    options={{bgClickClose: true}}>
                    <div className="product-popup">
                        <Grid
                            className="product-title-container"
                            container
                            spacing={0}>
                            <Grid className="product-title-grid" item xs={12}>
                                <span>{T('productDetails')}</span>
                            </Grid>
                        </Grid>

                        <Grid
                            className="product-details-container"
                            container
                            spacing={0}>
                            <Grid className="product-name-grid" item xs={12}>
                                {/*<span>{productInfo.productName}</span>*/}
                                <div
                                    className="checkbox-text"
                                    dangerouslySetInnerHTML={createMarkup(
                                        productInfo.productName,
                                    )}
                                />
                            </Grid>
                            <Grid
                                className="product-description-grid"
                                item
                                xs={12}>
                                {/*<span>{productInfo.description}</span>*/}
                                <div
                                    className="checkbox-text"
                                    dangerouslySetInnerHTML={createMarkup(
                                        productInfo.description,
                                    )}
                                />
                            </Grid>
                        </Grid>

                        <Grid
                            className="confirm-button-container"
                            container
                            spacing={0}>
                            <Grid className="confirm-button-grid" item xs={12}>
                                <BasicButton
                                    disabled={false}
                                    onClickOfSingleTap={this.closeDetails}>
                                    <span>{T('getInfo')}</span>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>

                <Dialog
                    contentStyle={{width: '100%'}}
                    dialogDidClose={this.closeCustomerInfo}
                    opened={customerInfoOpened}
                    options={{bgClickClose: true}}>
                    <div className="customer-info-popup">
                        <Grid
                            className="customer-info-container"
                            container
                            spacing={0}>
                            <Grid
                                className="customer-info-title-grid"
                                item
                                xs={12}>
                                <span>{T('order_contact_service')}</span>
                            </Grid>

                            <Grid
                                className="customer-info-mobile-grid"
                                item
                                xs={3}>
                                <span>{T('order_phone_colon')}</span>
                            </Grid>

                            <Grid
                                className="customer-info-mobile-grid"
                                item
                                xs={9}>
                                <span>{T('order_service_mobile')}</span>
                            </Grid>

                            <Grid item xs={3}></Grid>

                            <Grid
                                className="customer-info-mobile-grid"
                                item
                                xs={9}>
                                <span>{T('order_service_phone')}</span>
                            </Grid>

                            <Grid
                                className="customer-info-email-grid"
                                item
                                xs={3}>
                                <span>{T('order_service_mail')}</span>
                            </Grid>

                            <Grid
                                className="customer-info-email-grid"
                                item
                                xs={9}>
                                <span>{T('order_business_consult_email')}</span>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>

                <Dialog
                    contentStyle={{width: '100%'}}
                    dialogDidClose={this.closeQuoteDetails}
                    opened={quoteDetailsOpened}
                    options={{bgClickClose: true}}>
                    <div className="quote-popup">
                        <Grid className='className="quote-details-container"'>
                            <Promotions
                                promoData={target}
                                hasQuote={hasQuote}
                                copyContent={this.copyContent}
                                productDetail={productInfo}
                                customerData={
                                    this.props.customerData
                                }></Promotions>
                        </Grid>
                        <Grid className="confirm-button-container">
                            <Grid
                                className="confirm-button-grid grid-top"
                                item
                                xs={12}>
                                <BasicButton
                                    className="custom-promotion-confirm-btn"
                                    disabled={false}
                                    onClickOfSingleTap={this.closeQuoteDetails}>
                                    <span>{T('getInfo')}</span>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>
            </Card>
        );
    }
}

export default ProductCard;
